// @flow

export const MARKETPLACE_SETTINGS_INITIATE = 'MARKETPLACE_SETTINGS_INITIATE'
export const MARKETPLACE_SETTINGS_WERE_INITIATED =
  'MARKETPLACE_SETTINGS_WERE_INITIATED'

export const MARKETPLACE_SETTINGS_UPDATE = 'MARKETPLACE_SETTINGS_UPDATE'
export const MARKETPLACE_SETTINGS_WERE_UPDATED =
  'MARKETPLACE_SETTINGS_WERE_UPDATED'
